import React from "react";
import { useTheme } from "@mui/material/styles";

import { iconConfig, baseIconStyle } from "./iconConfig";

const IconResolver = ({
  name,
  color,
  size,
  style,
  fallback = "file",
  ...rest
}) => {
  const theme = useTheme();
  const cfg = iconConfig[name] || iconConfig[fallback];

  if (!cfg) return null;

  const IconComponent = cfg.component;

  const finalStyle = {
    ...baseIconStyle,
    color: theme.palette.custom.purple[600],
    ...cfg.style,
    ...(color ? { color } : {}),
    ...(size ? { fontSize: size } : {}),
    ...style,
  };

  return <IconComponent style={finalStyle} {...rest} />;
};

export default IconResolver;
